import {useEffect, useState} from 'react';
import {subscribeToErrorsUseCase} from '@/compositionRoot';
import type {AppError} from '@/domain/interfaces/ErrorService';

export const useController = () => {
  const [error, setError] = useState<AppError | undefined>();

  useEffect(() => {
    return subscribeToErrorsUseCase.execute((error) => setError(error));
  }, []);

  const handleClose = () => setError(undefined);

  return {
    error: error,
    onClose: handleClose,
  };
};
